//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { bioToHtml } from './sanitizeHtml.js';

export default {
  name: 'SessionSpeakerCard',

  props: {
    speaker: {
      type: Object,
      required: true,
    },
    colorIndex: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    bioHtml() {
      return bioToHtml(this.speaker.bio);
    },

    initials() {
      const parts = (this.speaker.name || '').split(' ').filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      return parts[0] ? parts[0][0].toUpperCase() : '';
    },

    avatarColor() {
      const colors = ['#2563EB', '#0F766E', '#10B981', '#036EBA'];
      return colors[this.colorIndex % colors.length];
    },

    speakerSubtitle() {
      return [this.speaker.title, this.speaker.organization].filter(Boolean).join(', ');
    },
  },
};
